export const EscapeHTML = () => {
    return value => {
        return value?.replace(/<[^>]*>/g, '').trim();
    };
};
